import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { version } from '../../../../package.json';
import { Config } from '../../core/model/service-config';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ContactoService } from '../../core/services/contacto.service';
import { ServiceConfigService } from '../../core/services/service-config.service';
import { SessionService } from '../../core/services/session.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  public version = version;
  isDocoutUser: boolean;
  Padre: string;
  emailsoporte: string;
  contactInfo: string;
  vInicial: string;
  constructor(
    private authService: AuthenticationService,
    private http: HttpClient,
    private utilitiesService: UtilitiesService,
    private toastr: ToastrService,
    private configService: ServiceConfigService,
    private contactoService: ContactoService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });
    this.authService.getClienteName$().pipe(first()).subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    });
    this.emailsoporte = this.authService.getEmailSoporte();
    this.contactoService.getCustomContactInfo().subscribe(info => this.contactInfo = info);
    this.contactoService.getDatosVideoInicial().subscribe(htmlVideoInicial => this.vInicial = htmlVideoInicial);
  }

  download(path?: string) {
    const clienteId = this.sessionService.getClientId();
    let manualPath;
    this.configService.getConfig(clienteId).pipe(first())
      .subscribe((config: Config) => {
        if (path) {
          manualPath = path;
        } else {
          if (this.authService.getManual() && this.authService.getManual() !== 'default') {
            manualPath = this.authService.getManual();
          } else {
            if (config.specificManual) {
              manualPath = `/assets/manual/${clienteId}_GestDocout360-ManualUsuario.pdf`;
            } else {
              manualPath = '/assets/manual/GestDocout360-ManualUsuario.pdf';
            }
          }
        }
        this.http.get(manualPath, { responseType: 'blob' }).pipe(first())
          .subscribe(data => {
            this.utilitiesService.downloadGenericFile(manualPath.substring(manualPath.lastIndexOf('/') + 1), data);
          }, error => {
            this.toastr.error('No ha sido posible descargar el manual de usuario');
          });
      }, error => {
        this.http.get('/assets/manual/GestDocout360-ManualUsuario.pdf', { responseType: 'blob' }).pipe(first())
          .subscribe(data => {
            this.utilitiesService.downloadGenericFile('GestDocout360-ManualUsuario.pdf', data);
          }, error2 => {
            this.toastr.error('No ha sido posible descargar el manual de usuario');
          });
      });
  }

  downloadVideoInicial(path?: string) {
    const clienteId = this.sessionService.getClientId();
    let manualPath;
    this.configService.getConfig(clienteId).pipe(first())
      .subscribe((config: Config) => {
        if (path) {
          manualPath = path;
        } else {
          if (this.authService.getManual() && this.authService.getManual() !== 'default') {
            manualPath = this.authService.getManual();
          } else {
            if (config.specificManual) {
              manualPath = `/assets/manual/${clienteId}_GestDocout360-ManualUsuario.pdf`;
            } else {
              manualPath = '/assets/manual/GestDocout360-ManualUsuario.pdf';
            }
          }
        }
        this.http.get(manualPath, { responseType: 'blob' }).pipe(first())
          .subscribe(data => {
            this.utilitiesService.downloadGenericFile(manualPath.substring(manualPath.lastIndexOf('/') + 1), data);
          }, error => {
            this.toastr.error('No ha sido posible descargar el manual de usuario');
          });
      }, error => {
        this.http.get('/assets/manual/GestDocout360-ManualUsuario.pdf', { responseType: 'blob' }).pipe(first())
          .subscribe(data => {
            this.utilitiesService.downloadGenericFile('GestDocout360-ManualUsuario.pdf', data);
          }, error2 => {
            this.toastr.error('No ha sido posible descargar el manual de usuario');
          });
      });


  }

}
